var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalPackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Pin",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Pin",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a2 2 0 100-4 2 2 0 000 4z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a7.115 7.115 0 00-4.94 1.978A6.68 6.68 0 001 6.784c0 2.763 1.572 4.945 3.038 6.388a15.85 15.85 0 003.081 2.35l.022.012a.286.286 0 01.005.003h.002l.015.01L8 16l.837-.453.015-.01.007-.003.022-.013a9.021 9.021 0 00.296-.176 15.851 15.851 0 002.785-2.174C13.428 11.73 15 9.548 15 6.785a6.68 6.68 0 00-2.06-4.806A7.116 7.116 0 008 0zM4.455 3.398A5.106 5.106 0 018 1.983c1.335 0 2.61.512 3.545 1.415A4.705 4.705 0 0113 6.784c0 1.994-1.142 3.696-2.447 4.98A13.955 13.955 0 018 13.735a13.956 13.956 0 01-2.553-1.97C4.142 10.48 3 8.778 3 6.784c0-1.265.52-2.483 1.455-3.386z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgLocalPackIcon;